module.exports = __webpack_public_path__ + "static/better-employee-03-1080w-b96159f693667f254866965e476ff1d6.jpg";